export const LOOKER_GROUP = 'ManheimApiOauth-AccountManagementService_Looker';
export const ADMIN_GROUP = 'ManheimApiOauth-AccountManagementService_Admin';
export const TIER2_GROUP = 'ManheimApiOauth-AccountManagementService_CCTier2';
export const EDIT_GROUP = 'ManheimApiOauth-AccountManagementService_CCEdit';
export const CIMANAGER_GROUP = 'ManheimApiOauth-AccountManagementService_CIManager';
